import React, { useEffect, useState } from 'react';

import Alert from '@amzn/meridian/alert';
import { statusMessage$ } from '../app-global-values';

/* Converts a Bootstrap warning variant into a Meridian warning type */
const convertVariantToType = variant => {
  switch (variant) {
    case 'success':
      return 'success';
    case 'danger':
      return 'error';
    case 'warning':
      return 'warning';
    default:
      return 'informational';
  }
};

const StatusMessage = () => {
  const [type, setType] = useState('success');
  const [message, setMessage] = useState(null);

  useEffect(() => {
    const statusMessageSubscription = statusMessage$.subscribe(value => {
      const messageType = value?.type ? value.type : convertVariantToType(value?.variant);
      setType(messageType);
      setMessage(value?.message);
    });

    return () => statusMessageSubscription.unsubscribe();
  }, []);

  if (!message) {
    return null;
  }

  return (
    <div className="mt-2 mr-2 ml-2">
      <Alert type={type} onClose={() => setMessage(null)}>
        {message}
      </Alert>
    </div>
  );
};

export default StatusMessage;
